import React from 'react';
import { useCart } from '../context/CartContext';

function OddsButton({ odds, isBest, selectionData, movement = 0, label, isEV = false, isArb = false }) {
  const { addSelection, removeSelection, selections } = useCart();

  // Handle null/undefined odds (e.g., sportsbook doesn't offer draw)
  if (odds == null) {
    return <span className="odds-button disabled">—</span>;
  }

  const matchingSelection = selections.find(
    s => s.eventId === selectionData.eventId
      && s.team === selectionData.team
      && (s.market || 'h2h') === (selectionData.market || 'h2h')
  );
  const isSelected = Boolean(matchingSelection);

  const formatOdds = (o) => o > 0 ? `+${o}` : o;

  const handleClick = (e) => {
    e.stopPropagation();
    if (isSelected) {
      removeSelection(matchingSelection.id);
    } else {
      addSelection(selectionData);
    }
  };

  return (
    <button
      className={`odds-button ${isBest ? 'best-odds' : ''} ${isSelected ? 'selected' : ''} ${isEV ? 'ev-plus' : ''} ${isArb ? 'arb-opp' : ''}`}
      onClick={handleClick}
      title={isSelected ? 'Click to remove from parlay' : 'Click to add to parlay'}
    >
      {(isEV || isArb) && (
        <span className="odds-badges">
          {isEV  && <span className="badge ev-badge">+EV</span>}
          {isArb && <span className="badge arb-badge">ARB</span>}
        </span>
      )}
      {label && <span className="odds-label">{label}</span>}
      <span className="odds-value">{formatOdds(odds)}</span>
      {movement > 0 && <span className="odds-up" title="Odds went up">▲</span>}
      {movement < 0 && <span className="odds-down" title="Odds went down">▼</span>}
    </button>
  );
}

export default OddsButton;
